import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getKyc = (params) => {
    return axios.get(`${backendHost}/api/admin/kyc/list`, {params});
};

export {
    getKyc
}